import { EVERYONE_PRINCIPAL_ID } from '@lucidlink/dto/validation';
export const verifyIsGroupEveryone = (groupId) => {
    return groupId === EVERYONE_PRINCIPAL_ID;
};
